import { useRef } from "react";
import "./DataTable.css";

export function DetailsPopover({ open, onClose, title, data, fields, actions }) {
  const containerRef = useRef(null);

  if (!open) return null;

  return (
    <div
      className="detailsOverlay"
      onClick={onClose}
      onKeyDown={(event) => {
        if (event.key === "Escape" || event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClose();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Close details"
    >
      <div
        className="detailsContainer"
        ref={containerRef}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="detailsHeader">
          {title && <span className="detailsTitle">{title}</span>}
          <button
            className="detailsCloseBtn"
            onClick={onClose}
            aria-label="close"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div className="detailsContent">
          {fields.map(({ key, label, render }) => {
            const value = data?.[key];
            return (
              <div key={key} className="detailsRow">
                <span className="detailsLabel">{label}</span>
                <span className="detailsValue">
                  {render ? render(value, data) : value ?? "N/A"}
                </span>
              </div>
            );
          })}
        </div>
        {actions ? <div className="detailsActions">{actions}</div> : null}
      </div>
    </div>
  );
}
